import { StaticImage } from 'gatsby-plugin-image';
import type { FC } from 'react';

import { ComponentsHead } from '@/components/head';
import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { LinkWithTitle } from '@/components/links';
import {
  h3,
  h4,
} from '@/styles/components/titles.module.scss';

export const LABOR_DAY_WEEKEND_TITLE = 'Labor Day Weekend';

export const Head = () => {
  return (
    <ComponentsHead
      title="Tampa Labor Day Charter | Final Summer Cruise"
      description="Send off summer in style with a Labor Day boat charter. Whether you’re chilling with friends or island hopping, this is your last big splash."
      keywords="Labor Day, End of Summer, Boat Charter, Tampa Events"
    />
  );
};

const SpecialEventsLaborDayWeekend: FC = () => {
  return (
    <AddOnsTemplate
      title="Labor Day Weekend Boat Charters – End Your Summer Right"
      subtitle="Labor Day Weekend Boat Charters – End Your Summer Right"
    >
      <div style={{ height: '2rem' }} />
      <GalleriesItem>
        <StaticImage
          alt={`${LABOR_DAY_WEEKEND_TITLE} header`}
          src="../../images/special-events/labor-day-weekend/DJ-crew-relaxing-boat-ride.jpg"
        />
      </GalleriesItem>
      <h3 className={h3}>A Stylish Send-Off to Summer</h3>
      <p>
        The start of autumn approaches with Labor Day which
        serves as the unofficial end of summer when we use
        this time to unwind and enjoy our last extended
        weekend of the season. During Labor Day, people from
        all over the country unite to spend their days at
        barbecues, beaches and on water activities. The
        pleasant Tampa Bay weather conditions create an
        excellent opportunity for people to experience
        memorable boating adventures.
      </p>
      <p>
        Your Labor Day Weekend should end with a luxurious
        boat charter. During this holiday weekend, Tampa Bay
        transforms into an excellent spot for people who
        want to spend their day peacefully on the water.{' '}
        <LinkWithTitle to="/blog/welcome-to-tampa-bay-boating-adventures/">
          Our private charters
        </LinkWithTitle>{' '}
        create a peaceful and elegant retreat that suits
        relaxation or bay exploration or family gatherings.
      </p>
      <p>
        Your{' '}
        <LinkWithTitle to="/services/">
          4-hour cruise
        </LinkWithTitle>{' '}
        starting from{' '}
        <LinkWithTitle to="/faqs/">
          Davis Island Boat Ramp
        </LinkWithTitle>{' '}
        will guide you along the stunning routes of Tampa
        Bay. You can witness the city skyline while sailing
        by Harbour Island before finding peaceful waters to
        relax and swim if you choose to do so.
      </p>
      <h4 className={h4}>
        Everything You Need for a Perfect Day
      </h4>
      <p>
        Your floating farewell party awaits you at this
        location. Both the TBBA Adventure I and Paradiso
        vessels provide luxurious comfort during your time
        on the water regardless of whether you have a small
        group or a larger one. You can enjoy your summer
        playlist while drinking chilled beverages from the
        cooler and swimming from the platform.
      </p>
      <p>
        You can enhance your experience with optional add
        ons such as gourmet food choices while also getting
        items to take home as mementos from your day. The
        bay offers spectacular views because you will be
        positioned between the skyline and open water while
        saying farewell to summer in an unforgettable
        manner.
      </p>
    </AddOnsTemplate>
  );
};

export default SpecialEventsLaborDayWeekend;
